import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { mediaUrl } from '../utils/media';

const ProfilePictureZoom = ({ src, alt = 'Profile', size = 'w-24 h-24', className = '', children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const resolvedSrc = mediaUrl(src);

  if (!resolvedSrc && !children) return null;

  return (
    <>
      <div onClick={() => setIsOpen(true)} className={`cursor-zoom-in ${className}`} data-testid="profile-picture-zoom-trigger">
        {children || (
          <img src={resolvedSrc} alt={alt} className={`${size} rounded-full object-cover border-2 border-white shadow-md`} />
        )}
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
            onClick={() => setIsOpen(false)}
            data-testid="profile-picture-zoom-modal"
          >
            <motion.div
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              transition={{ type: 'spring', damping: 25 }}
              className="relative max-w-md w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsOpen(false)}
                className="absolute -top-3 -right-3 p-2 bg-white rounded-full shadow-lg text-slate-600 hover:text-slate-900 z-10"
                data-testid="close-zoom-btn"
              >
                <X className="h-5 w-5" />
              </button>
              <img
                src={resolvedSrc}
                alt={alt}
                className="w-full rounded-2xl object-contain max-h-[70vh] shadow-2xl"
              />
              {alt && <p className="text-white text-center text-sm mt-3 font-medium">{alt}</p>}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ProfilePictureZoom;
